<style scoped>
.v-data-table__wrapper th:nth-child(1),
.v-data-table__wrapper td:nth-child(1) {
  max-width: 90px;
}

.v-data-table__wrapper th:nth-child(2),
.v-data-table__wrapper td:nth-child(2) {
  min-width: 260px;
  max-width: 260px;
}

.v-data-table__wrapper th:nth-child(3),
.v-data-table__wrapper td:nth-child(3) {
  min-width: 150px;
  max-width: 300px;
}

.v-data-table__wrapper th:nth-child(4),
.v-data-table__wrapper td:nth-child(4) {
  max-width: 90px;
}

.v-data-table__wrapper th:nth-child(5),
.v-data-table__wrapper td:nth-child(5) {
  min-width: 240px;
}

.v-data-table__wrapper td {
  vertical-align: middle;
}

.scenario-input {
  display: flex;
  align-items: center;
  min-height: 40px;
}

.switch-small-label::v-deep .v-label {
  font-size: 12px;
}

.switch-small-label::v-deep .v-input--switch__track {
  opacity: 1;
  border-radius: 12px;
  height: 20px;
  width: 36px;
  top: calc(50% - 10px);
}

.switch-small-label::v-deep .v-input--switch__thumb {
  width: 14px;
  height: 14px;
  top: calc(50% - 7px);
  left: 3px;
  color: white !important;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
}

.switch-small-label::v-deep .v-input--selection-controls__ripple {
  display: none;
}

::v-deep input[type='number']::-webkit-inner-spin-button,
::v-deep input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

::v-deep input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}
</style>
<template>
  <div>
    <v-simple-table class="pb-5">
      <template #default>
        <thead>
          <tr>
            <th class="text-left">
              {{ $t('newPackage.campaign.header[0]') }}
            </th>
            <th class="text-left">
              {{ $t('newPackage.campaign.header[1]') }}
            </th>
            <th class="text-left">
              {{ $t('newPackage.campaign.header[2]') }}
            </th>
            <th class="text-left">
              {{ $t('newPackage.campaign.header[3]') }}
            </th>
            <th class="text-left">
              {{ $t('newPackage.campaign.header[4]') }}
            </th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(campaign, index) in campaigns" :key="index">
            <td>{{ index + 1 }}</td>
            <td>
              <div class="scenario-input">
                <v-chip
                  v-if="campaign.isDynamic"
                  small
                  outlined
                  color="#1b2643"
                >
                  <v-icon left x-small>mdi-lightning-bolt</v-icon>
                  {{ $t('newPackage.campaign.dynamicScenarioHint') }}
                </v-chip>
                <v-select
                  v-else
                  v-model="campaign.scenarioDocId"
                  :items="availableScenarios"
                  :item-text="getScenarioDisplayName"
                  item-value="id"
                  :value-comparator="scenarioValueComparator"
                  dense
                  hide-details
                  class="flex-grow-1"
                  @change="
                    $emit('update-campaign', {
                      index,
                      field: 'scenarioDocId',
                      value: campaign.scenarioDocId,
                    })
                  "
                ></v-select>
              </div>
              <v-checkbox
                :input-value="campaign.isDynamic"
                :label="$t('newPackage.campaign.dynamicScenario')"
                dense
                hide-details
                class="ma-0 pa-0 switch-small-label"
                @change="
                  $emit('update-campaign', {
                    index,
                    field: 'isDynamic',
                    value: $event,
                  })
                "
              ></v-checkbox>
            </td>
            <td>
              <v-text-field
                v-model="campaign.name"
                :rules="[rules.required]"
                dense
                @input="
                  $emit('update-campaign', {
                    index,
                    field: 'name',
                    value: campaign.name,
                  })
                "
              ></v-text-field>
            </td>
            <td>
              <v-menu
                v-model="campaign.limitMenuOpen"
                offset-y
                :close-on-content-click="true"
              >
                <template #activator="{}">
                  <v-text-field
                    v-if="campaign.limits !== null"
                    variant="solo"
                    v-model.number="campaign.limits"
                    type="number"
                    min="1"
                    dense
                    :rules="[rules.minOne]"
                    append-icon="mdi-menu-down"
                    @click:append="campaign.limitMenuOpen = true"
                  />
                  <v-text-field
                    v-else
                    :value="$t('newPackage.campaign.unlimited')"
                    variant="solo"
                    dense
                    hide-details
                    readonly
                    append-icon="mdi-menu-down"
                    @click:append="campaign.limitMenuOpen = true"
                  />
                </template>
                <v-list dense>
                  <v-list-item
                    @click="onLimitTypeChange(campaign, index, 'specify')"
                  >
                    <v-list-item-title>{{
                      $t('newPackage.campaign.specify')
                    }}</v-list-item-title>
                  </v-list-item>
                  <v-list-item
                    @click="onLimitTypeChange(campaign, index, 'unlimited')"
                  >
                    <v-list-item-title>{{
                      $t('newPackage.campaign.unlimited')
                    }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </td>
            <td class="pa-0">
              <v-container class="d-flex align-center" style="gap: 10px">
                <v-switch
                  v-model="campaign.isSameAsViewingPeriod"
                  :label="$t('campaignSetting.sameAsPublicPeriod')"
                  dense
                  color="#1b2643"
                  class="mt-0 switch-small-label"
                  hide-details
                  @change="onSameAsViewingPeriodChange(campaign, index)"
                />
                <v-container class="d-flex align-end pa-0" style="gap: 5px">
                  <v-icon small class="pa-0">mdi-tilde</v-icon>
                  <v-container class="d-flex flex-column pa-0">
                    <v-container class="pa-0">
                      <DateTimePicker
                        :date="campaign.startInterviewDate"
                        :hasPeriodError="!!campaign.errorMessage"
                        :time="campaign.startInterviewTime"
                        :disabled="campaign.isSameAsViewingPeriod"
                        @update:date="
                          $emit('update-campaign', {
                            index,
                            field: 'startInterviewDate',
                            value: $event,
                          })
                        "
                        @update:time="
                          $emit('update-campaign', {
                            index,
                            field: 'startInterviewTime',
                            value: $event,
                          })
                        "
                        @validate-period="
                          $emit('validate-period', { campaign, index })
                        "
                      />
                    </v-container>
                    <v-container class="pa-0">
                      <DateTimePicker
                        :date="campaign.endInterviewDate"
                        :hasPeriodError="!!campaign.errorMessage"
                        :time="campaign.endInterviewTime"
                        :disabled="campaign.isSameAsViewingPeriod"
                        @update:date="
                          $emit('update-campaign', {
                            index,
                            field: 'endInterviewDate',
                            value: $event,
                          })
                        "
                        @update:time="
                          $emit('update-campaign', {
                            index,
                            field: 'endInterviewTime',
                            value: $event,
                          })
                        "
                        @validate-period="
                          $emit('validate-period', { campaign, index })
                        "
                      />
                    </v-container>
                  </v-container>
                </v-container>
              </v-container>
              <span class="error--text text-caption text-center">
                {{ campaign.errorMessage }}
              </span>
            </td>
            <td>
              <v-container class="d-flex">
                <v-btn
                  :disabled="index === 0"
                  icon
                  small
                  @click="$emit('move-up', index)"
                >
                  <v-icon small>mdi-arrow-up</v-icon>
                </v-btn>
                <v-btn
                  :disabled="index === campaigns.length - 1"
                  icon
                  small
                  @click="$emit('move-down', index)"
                >
                  <v-icon small>mdi-arrow-down</v-icon>
                </v-btn>
                <v-btn
                  :disabled="campaigns.length === 1"
                  icon
                  small
                  @click="$emit('delete-campaign', index)"
                >
                  <v-icon small>mdi-trash-can-outline</v-icon>
                </v-btn>
              </v-container>
            </td>
          </tr>
        </tbody>
      </template>
    </v-simple-table>
    <v-btn
      elevation="0"
      small
      style="width: 100%"
      @click="$emit('create-campaign')"
    >
      <v-icon small>mdi-plus</v-icon>
    </v-btn>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from "@vue/composition-api";
import DateTimePicker from "@/components/Dashboard/PageViewItems/DateTimePicker.vue";
import type { ScenarioWithId } from "@/resources/scenario";

interface ModifiableCampaignLineItem {
  id?: string;
  name?: string;
  scenarioDocId?: string;
  isDynamic?: boolean;
  isSameAsViewingPeriod?: boolean;
  startInterviewDate?: string | null;
  startInterviewTime?: string;
  endInterviewDate?: string | null;
  endInterviewTime?: string;
  errorMessage?: string;
  limits?: number | null;
  limitMenuOpen?: boolean;
  index?: number;
}

export default defineComponent({
  name: "ModifiableCampaignTable",
  components: { DateTimePicker },
  props: {
    campaigns: {
      type: Array as PropType<ModifiableCampaignLineItem[]>,
      required: true,
    },
    availableScenarios: {
      type: Array as PropType<ScenarioWithId[]>,
      required: true,
    },
    rules: {
      type: Object as PropType<
        Record<string, (value: string) => boolean | string>
      >,
      required: true,
    },
    getScenarioDisplayName: {
      type: Function as PropType<(scenario: ScenarioWithId) => string>,
      required: true,
    },
    startViewingDate: {
      type: String as PropType<string | null>,
      default: null,
    },
    startViewingTime: {
      type: String,
      default: "",
    },
    endViewingDate: {
      type: String as PropType<string | null>,
      default: null,
    },
    endViewingTime: {
      type: String,
      default: "",
    },
  },
  methods: {
    scenarioValueComparator(a: string, b: string): boolean {
      if (a === b) return true;

      const scenarioA = this.availableScenarios.find(
        (s) => s.id === a || s.scenarioIdLegacy === a,
      );
      const scenarioB = this.availableScenarios.find(
        (s) => s.id === b || s.scenarioIdLegacy === b,
      );

      return scenarioA === scenarioB && scenarioA !== undefined;
    },

    onLimitTypeChange(
      campaign: ModifiableCampaignLineItem,
      index: number,
      type: string,
    ) {
      campaign.limits = type === "unlimited" ? null : 1;
      this.$emit("update-campaign", {
        index,
        field: "limits",
        value: campaign.limits,
      });
    },

    onSameAsViewingPeriodChange(
      campaign: ModifiableCampaignLineItem,
      index: number,
    ) {
      if (campaign.isSameAsViewingPeriod) {
        campaign.startInterviewDate = this.startViewingDate;
        campaign.startInterviewTime = this.startViewingTime;
        campaign.endInterviewDate = this.endViewingDate;
        campaign.endInterviewTime = this.endViewingTime;
        campaign.errorMessage = "";
      } else {
        campaign.startInterviewDate = null;
        campaign.startInterviewTime = "00:00";
        campaign.endInterviewDate = null;
        campaign.endInterviewTime = "23:59";
      }
      this.$emit("same-as-viewing-period-change", { campaign, index });
    },
  },
});
</script>
